import React from 'react';
import ActionButton from 'components/ActionButton';
import executeFunctionList from 'utils/executeFunctionList';
import { useClosure } from 'utils/hooks';
import { MailTemplateSubtype, MailTemplateType } from 'helper/mailer';

export interface SelectedTemplate {
  type: MailTemplateType,
  subType: MailTemplateSubtype,
}

interface MailTemplateListItemEditButton {
  type: MailTemplateType,
  subType: MailTemplateSubtype,
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>,
  setSelectedTemplate: React.Dispatch<React.SetStateAction<SelectedTemplate | null>>,
}

export default function EditButton({
  setModalOpen, setSelectedTemplate, type, subType,
}: MailTemplateListItemEditButton) {
  return (
    <ActionButton
      icon="edit"
      onClick={executeFunctionList([
        useClosure(setModalOpen, true),
        useClosure(setSelectedTemplate, { type, subType }),
      ])}
      tooltipText="Editar template"
    />
  );
}
